import { useDidFinishSSR } from '@tamagui/core'
import Link from 'next/link'
import { SizableText, SizableTextProps } from 'tamagui'

export type ClientHostLinkProps = {
  href?: string
  text?: string
} & SizableTextProps

export const ClientHostLink = ({ href = '/', text, ...props }: ClientHostLinkProps) => {
  const isClientSide = useDidFinishSSR()
  if (!isClientSide) return null

  return (
    <Link href={`${href ?? '/'}`}>
      <SizableText color="$blue9" {...props}>
        {text ?? location.hostname.replace('www.', '')}
      </SizableText>
    </Link>
  )
}
